import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkdayModel } from '../models/low-level/workday.model';

/**
 * Public contract of the weekly-work-time service: the running week's per-day work durations and
 * the two totals the header and side-menu panel read.
 *
 * Implemented by both the legacy `WeeklyWorkTimeService` (file/concurrency-store-backed) and the
 * NgRx-backed `WeeklyWorkTimeNgrxService`; consumers depend on this interface via
 * {@link WeeklyWorkTimeInstanceToken} rather than on a concrete class.
 *
 * Deliberately not part of the contract, because nothing outside the service calls them:
 * `getWeeklyWorkTimeList()`, `updateWeeklyWorkTimeValue$`, `displayWeeklyWorkTime`. The app header
 * computes its own `displayWeeklyWorkTime` from `ConfigInterface`.
 */
export interface WeeklyWorkTimeInterface {
    init(): Observable<unknown>;

    syncWeeklyWorkTime(): Observable<void>;

    weeklyWorkTimeValue$: Observable<WorkdayModel[]>;

    getTotalWeekDuration(): number;

    getCurrentDayTotalDuration(): number;
}

/**
 * DI token for {@link WeeklyWorkTimeInterface}. Lets the app choose which implementation to
 * provide (legacy `WeeklyWorkTimeService` or the NgRx-based `WeeklyWorkTimeNgrxService`) without
 * consumers depending on a concrete class.
 */
export const WeeklyWorkTimeInstanceToken = new InjectionToken<WeeklyWorkTimeInterface>('WeeklyWorkTimeInterface');
